import { animated, useSpring } from "@react-spring/web";
import React, { ForwardedRef, forwardRef, useEffect, useState } from "react";

import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

//components
import Icon from "../../../Icon/Icon";
import IconButton, { IconButtonProps } from "../../IconButton";

declare interface RotatingIconButtonProps extends IconButtonProps {
	reverseDirection?: boolean;
	isActiveOverride?: boolean;
	icon: IconDefinition;
	className?: string;
}

/**
 * @deprecated Use the ButtonIcon component from the py-components package instead
 */
const RotatingIconButton = forwardRef((props: RotatingIconButtonProps, ref: ForwardedRef<HTMLButtonElement>) => {
	const passedProps = { ...props, icon: undefined, onClick: null };
	const [isActive, setIsActive] = useState(props.isActiveOverride || false);

	const springs = useSpring({
		transform: isActive ? `rotate(${props.reverseDirection ? "-" : ""}180deg)` : "rotate(0deg)",
	});

	useEffect(() => {
		setIsActive(!!props.isActiveOverride);
	}, [props.isActiveOverride]);

	return (
		<IconButton
			ref={ref}
			{...passedProps}
			isHollow={true}
			square={true}
			onClick={() => {
				setIsActive(!isActive);
				props.onClick && props.onClick();
			}}
		>
			{
				<animated.div style={springs}>
					<Icon icon={props.icon} size="small" />
				</animated.div>
			}
		</IconButton>
	);
});
RotatingIconButton.displayName = "RotatingIconButton";

export default RotatingIconButton;
